import { render, staticRenderFns } from "./RegisteredProductsClosedRepair.vue?vue&type=template&id=53a1020a"
import script from "./RegisteredProductsClosedRepair.vue?vue&type=script&lang=js"
export * from "./RegisteredProductsClosedRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports